// Menu Lateral
import React from 'react'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import { Menu as MenuAntd, Icon, Layout, Button } from 'antd'
import { slide as Slide } from 'react-burger-menu'
import { LogoSmall, LogoMiddle, IconCustom } from '../utils/Utils'
const { SubMenu, Item } = MenuAntd
const { Sider } = Layout

const menuData = [ {
  name: 'Mochileros',
  route: '/mochileros',
  icon: 'icon-mochileros',
  items: [
    { name: 'Pressure', route: '/pressure', icon: 'dashboard', custom: false },
    { name: 'Flow', route: '/flow', icon: 'icon-graphic_eq', custom: true },
    { name: 'Temperature', route: '/temperature', icon: 'icon-thermometer', custom: true }
  ]
}, {
  name: 'Paez',
  route: '/paez',
  icon: 'icon-paez',
  items: [
    { name: 'Pressure', route: '/pressure', icon: 'dashboard', custom: false },
    { name: 'volumen', route: '/volumen', icon: 'bar-chart', custom: false }
  ]
}, {
  name: 'Valle de Tenza',
  route: '/valledetenza',
  icon: 'icon-valledetenza',
  items: [
    { name: 'Pressure', route: '/pressure', icon: 'dashboard', custom: false },
    { name: 'Flow', route: '/flow', icon: 'icon-graphic_eq', custom: true },
    { name: 'Temperature', route: '/temperature', icon: 'icon-thermometer', custom: true }
  ]
}, {
  name: 'Umbita',
  route: '/umbita',
  icon: 'icon-valledetenza',
  items: [
    {name: 'Pressure', route: '/pressure', icon: 'dashboard', custom: false},
    {name: 'Temperature', route: '/temperature', icon: 'icon-thermometer', custom: true},
    {name: 'Volume', route: '/volumen', icon: 'icon-graphic_eq', custom: true}
  ]
}]

export default class Menu extends React.Component {
  onToggleMenu (state) {
    this.props.onToggleMenu(state)
  }

  onChangeView (closeMenuOnChangeView) {
    if (closeMenuOnChangeView) {
      this.props.onToggleMenu()
    }
  }

  render () {
    const item = ({ name, icon, custom, route }) => (
      <Item key={route}>
        <Link to={route}>
          {custom ? <IconCustom type={icon} /> : <Icon type={icon} />}
          <span>{name}</span>
        </Link>
      </Item>
    )

    const subMenu = ({ name, icon, items, route }, general) => {
      let title = (
        <span>
          <IconCustom type={icon} />
          <span>{name}</span>
        </span>
      )

      return (
        <SubMenu key={route} title={title}>
          {
            general
              ? <Item key={route}>
                <Link to={route}>
                  <Icon type='appstore' />
                  <span>General</span>
                </Link>
              </Item>
              : null
          }
          {items.map(i => ({ ...i, route: route.concat(i.route) })).map(item)}
        </SubMenu>
      )
    }
    let menu = (dark, closeMenuOnClick) => (
      <MenuAntd
        defaultOpenKeys={['/'.concat(this.props.location.split('/')[1])]}
        selectedKeys={[this.props.location === '/' ? '/home' : this.props.location]}
        onClick={() => { this.onChangeView(closeMenuOnClick) }}
        mode='inline'
        theme={dark ? 'dark' : null}
      >
        {item({ name: 'Home', icon: 'home', custom: false, route: '/home' })}
        {/* si el menu es dark se muestra la vista general */}
        {menuData.map(s => subMenu(s, dark))}
      </MenuAntd>
    )

    let sider = (
      <Slide
        width={280}
        className='slide'
        onStateChange={this.onToggleMenu.bind(this)}
        isOpen={this.props.isOpenMenu}
        customBurgerIcon={false}
      >
        <div>
          <Button
            icon={this.props.isOpenMenu ? 'menu-fold' : 'menu-unfold'}
            className='btn-border-less'
            onClick={() => this.onToggleMenu.bind(this)()}
          />
          <LogoSmall />
        </div>
        {menu(false, true)}
      </Slide>
    )

    let siderAntd = (
      <Sider
        collapsed={!this.props.isOpenMenu}
        width={280}
        style={{ overflow: 'auto', overflowX: 'hidden' }}>
        <LogoMiddle collapsed={!this.props.isOpenMenu} />
        {menu(true, false)}
      </Sider>
    )

    return (
      <MediaQuery maxWidth={1279}>
        {matches => matches ? sider : siderAntd}
      </MediaQuery>
    )
  }
}



// WEBPACK FOOTER //
// ./src/utils/Menu.js